// move layout and video with image preview
jQuery(document).ready(function ($) {
   $(".section-for-popup .content_wrap").each(function(){
     var clone = $(this).children("p").children("img").clone();
     $(this).children("p").children("img").remove();
     $(this).children(".video-wrapper").prepend(clone);
     $(this).children(".video-wrapper").children("img").click(function(){
       $(this).parent(".video-wrapper").children("iframe")[0].src += "?autoplay=1";
       $(this).parent(".video-wrapper").children("iframe").addClass("show");
       $(this).parent(".video-wrapper").addClass("hide");
     })                                                
   });

  /**
   * reset video when close
   */
    $(".template-product .section-for-popup .close_btn_wrap").click(function () {
    $(".section-for-popup .video-wrapper").removeClass("hide");
    $(".section-for-popup .prose iframe").removeClass("show");
    $(".section-for-popup .video-wrapper iframe").each(function () {
      var position = $(this)[0].src.indexOf("?autoplay=1");
      if (position != -1) {
        $(this)[0].src = $(this)[0].src.slice(0, position);
      }
    })
  });

  /**
   * reset video when close
   */
    $(".template-product .section-for-popup .section_bg").click(function () {
    $(".section-for-popup .video-wrapper").removeClass("hide");
    $(".section-for-popup .prose iframe").removeClass("show");
    $(".section-for-popup .video-wrapper iframe").each(function () {
      var position = $(this)[0].src.indexOf("?autoplay=1");
      if (position != -1) {
        $(this)[0].src = $(this)[0].src.slice(0, position);
      }
    })
  })

  /**
   * popup for How Subscriptions Work?
   */
  $(".modal-popup-subscription-button").on("click", function () {
    $('#modal-popup-subscription-page').fadeIn();
    $('#modal-popup-subscription-page').addClass('tooltip_drawer_open');
  });

  /**
   * popup for How Much Coffee Should I Get?
   */
  $(".modal-popup-how-much-button").on("click", function () {
    $('#modal-popup-how-much-page').fadeIn();
    $('#modal-popup-how-much-page').addClass('tooltip_drawer_open');
  });

  /**
   * Close popup
   */
  $('.section-for-popup').on('click', '.close_btn_wrap', function () {
    $('.section-for-popup').removeClass('tooltip_drawer_open');
    $('.section-for-popup').addClass('tooltip_drawer_close');
    setTimeout(() => {
      $('.section-for-popup').removeClass('tooltip_drawer_close');
    }, 500);
    $('.section-for-popup').fadeOut();
  });
  $('.section-for-popup').on('click', '.section_bg', function () {
    $('.section-for-popup').removeClass('tooltip_drawer_open');
    $('.section-for-popup').addClass('tooltip_drawer_close');
    setTimeout(() => {
      $('.section-for-popup').removeClass('tooltip_drawer_close');
    }, 500);
    $('.section-for-popup').fadeOut();
  });



})






